/* global require,module */
require('./directives/popup');
require('./directives/bubble');
require('./directives/dialog');
require('./directives/notice');
require('./services/popup');
module.exports = {};// webpack


//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 0
// module chunks = 0